import React, { useState } from 'react'

import cx from 'classnames'

import { COLOR_BLUE } from '@/utils/styles'

import { AnimatedCollapse, CollapsibleElement } from '../Animations/AnimatedCollapse'
import { Arrow } from '../Icons/Arrow'
import { Loader } from '../Loader'

import styles from './CollapsibleContainer.module.scss'

const CollapsibleContainer: React.FC<{
  title: React.ReactNode
  loading?: boolean
  className?: string
  defaultOpen?: boolean
  children: CollapsibleElement
  alwaysOpen?: boolean
  'data-cy'?: string
}> = ({ children, title, loading, className, defaultOpen = false, 'data-cy': dataCy, alwaysOpen }) => {
  const [open, setOpen] = useState(defaultOpen || alwaysOpen)

  if (loading) {
    return (
      <div className={cx(styles.Container, className)}>
        <div className={styles.ContainerLoader} data-cy={dataCy + '-loader'}>
          <Loader strokeColor={COLOR_BLUE} />
        </div>
      </div>
    )
  }

  const handleClick = () => {
    if (!alwaysOpen) {
      setOpen(!open)
    }
  }

  return (
    <div className={cx(styles.Container, className)}>
      <div className={styles.Header} onClick={handleClick} data-cy={dataCy}>
        <h2>{title}</h2>
        {!alwaysOpen && <Arrow className={styles.Arrow} direction={open ? 'Up' : 'Down'} />}
      </div>
      <AnimatedCollapse collapse={!open}>{children}</AnimatedCollapse>
    </div>
  )
}

export default CollapsibleContainer
